export type QuestionRegionKind = 'prompt' | 'stem';

/** The grammar is frozen by the anchor model (persisted from part-4 on); do not vary it. */
export function buildQuestionRegionId(questionId: string, kind: QuestionRegionKind): string {
  return `question:${questionId}:${kind}`;
}
